var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import Progress from "../Partials/Progress";
import AppLayout from "@/Layouts/AppLayout";
import Breadcrumb from "@/Jetstream/Breadcrumb";
import FileUpload from "@/Pages/Certificate/Partials/FileUpload";
function Tertiary(_a) {
    var team = _a.team, branch = _a.branch, certificate = _a.certificate;
    return _jsx("div", __assign({ className: "" }, { children: _jsx(FileUpload, { team: team, branch: branch, certificate: certificate }) }));
}
export default function StepLayout(_a) {
    var children = _a.children, team = _a.team, branch = _a.branch, certificate = _a.certificate, form = _a.form, _b = _a.hideSidebar, hideSidebar = _b === void 0 ? false : _b, _c = _a.tertiary, tertiary = _c === void 0 ? null : _c;
    return _jsx(AppLayout, __assign({ title: "Certificate", pageTitle: "Create AHC", breadCrumb: _jsx(Breadcrumb, { team: team, branch: branch, client: certificate === null || certificate === void 0 ? void 0 : certificate.client, current: "Certificate" }), tertiary: hideSidebar ? null : (tertiary ? tertiary : _jsx(Tertiary, { team: team, branch: branch, certificate: certificate })), aside: _jsx(Progress, { team: team, branch: branch, certificate: certificate, step: form.data._step, onChange: function () { } }) }, { children: children }));
}
